<template src="./Contract.html"></template>
<script>
import mixins from "../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      idCompany: null,
      popupContract: false,
      contract: {},
      invalidFields: {
        name: false,
      },
      companyName: "",
      myContracts: [],
      name: "",
      billed: "",
      issueRPS: false,
      fillMedicalRecordRequired: false,
      chargeWithdrawalFee: false,
      active: false,
      titlePopContract: "",
      showContract: false,
      contracts: [],
    };
  },
  watch: {
    name: function(newVal){
      const vm = this;
      if(vm.testNullUndefinedEmpty(newVal)){
        vm.invalidFields.name = false;
      }
    },
  },
  mounted: function () {
    const vm = this;
    if (vm.testNullUndefinedEmpty(vm.$route.params.id) === false) {
      vm.idCompany = vm.$route.params.id;
      vm.companyName = vm.$route.params.name.toUpperCase();
      vm.init();
    }
  },
  methods: {
    init() {
      const vm = this;
      vm.getContracts();
    },
    editContract(contractId) {
      const vm = this;
      vm.titlePopContract = "Editar contrato";
      vm.getContract(contractId);
    },
    addNewContract() {
      const vm = this;
      vm.contractId = null;
      vm.titlePopContract = "Novo contrato";
      vm.name = "";
      vm.billed = "";
      vm.issueRPS = false;
      vm.fillMedicalRecordRequired = true;
      vm.active = false;
      vm.chargeWithdrawalFee = true;
      vm.contract = {};
      vm.popupContract = true;
    },
    getContracts() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "company/contract/" + vm.idCompany, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.myContracts = response.data;
          }
        });
    },
    getContract(contractId) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer + "contract/find_by_id/" + contractId,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.contract = response.data;
            vm.fillContract();
          }
        });
    },
    fillContract() {
      const vm = this;
      vm.issueRPS = vm.contract.billed !== true;
      vm.active = vm.contract.active;
      vm.name = vm.contract.name;
      vm.fillMedicalRecordRequired =  vm.contract.notFillMedicalRecord !== true;
      vm.chargeWithdrawalFee =  vm.contract.notChargeWithdrawalFee !== true;
      vm.popupContract = true;
    },
    validateFields() {
      const vm = this;
      let valid = true;
      if (vm.testNullUndefinedEmpty(vm.name)) {
        valid = false;
        vm.invalidFields.name = true;
      }
      if (valid === false) {
        vm.$vs.notify({
              title: "Atenção!",
              text: "Campos obrigatórios não preenchidos ou inválidos!",
              color: "warning",
              icon: "error_outline",
              position: "top-right",
            });
      } else {
        if (vm.testNullUndefinedEmpty(vm.contract.id)) {
          vm.saveNewContract();
        } else {
          vm.updateContract();
        }
      }
    },
    saveNewContract() {
      const vm = this;
      let contract = {
        name: vm.name,
        active: vm.active,
        notFillMedicalRecord: vm.fillMedicalRecordRequired !== true,
        notChargeWithdrawalFee: vm.chargeWithdrawalFee !== true,
        billed: vm.issueRPS !== true,
      };

      vm.axios
        .post(vm.$store.state.filooServer + "company/contract/" + vm.idCompany , contract, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.popupContract = false;
            vm.$swal("Operação realizada", "O contrato <b style='color: #FF9F43; font-weight: 500'>" + contract.name + "</b> foi criado com sucesso!" , "success");
            vm.getContracts();
          }
        })
        .catch(function () {
          vm.popupContract = false;
          vm.$swal("Atenção!", "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema", "error");
        });
    },
    updateContract() {
      const vm = this;
      let contract = {
        id: vm.contract.id,
        name: vm.name,
        active: vm.active,
        notFillMedicalRecord: vm.fillMedicalRecordRequired !== true,
        notChargeWithdrawalFee: vm.chargeWithdrawalFee !== true,
      };
      contract.billed = vm.issueRPS !== true;
      vm.axios
        .put(vm.$store.state.filooServer + "contract/", contract, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.popupContract = false;
            vm.$swal("Operação realizada!", "Os dados do contrato <b style='color: #FF9F43; font-weight: 500'>" + contract.name + "</b> foram alterados com sucesso!", "success");
            vm.getContracts();
          }
        })
        .catch(function () {
          vm.popupContract = false;
          vm.$swal("Atenção!", "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema", "error");
        });
    },
  },
};
</script>

<style lang="scss" src="./Contract.scss">
</style>
